export default __webpack_public_path__ + "static/media/mctvideo.2befda14.mp4";